module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "title-container",
    staticStyle: {
      "width": "60em"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "relative",
      "left": "-110px",
      "margin-bottom": "80px"
    },
    attrs: {
      "src": require("./../assets/cfe-logo.png")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "relative",
      "left": "230px",
      "margin-bottom": "80px"
    },
    attrs: {
      "src": require("./../assets/bc_hlth.png")
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "sub-title",
    staticStyle: {
      "padding-left": "150px"
    }
  }, [_vm._v("FOR " + _vm._s(_vm.$route.params.ha === 'bc' ? 'BRITISH COLUMBIA' : this.$parent.haName.toUpperCase()))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "150px",
      "font-size": "1.5rem"
    }
  }, [_vm._v(_vm._s(_vm.quarter) + " QUARTER " + _vm._s(_vm.year))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title",
    staticStyle: {
      "padding-left": "150px"
    }
  }, [_vm._v("HIV Monitoring"), _c('br'), _vm._v("Quarterly Report")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "id": "using-safari",
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_c('i', {
    staticClass: "fa fa-safari",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Heads Up")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "mb-0"
  }, [_vm._v("It seems that you are using the Safari web browser. However, this website is best viewed using "), _c('a', {
    attrs: {
      "href": "https://www.google.com/chrome/browser/desktop/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Chrome")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "logos top-padded-2x",
    attrs: {
      "border": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('img', {
    staticClass: "logo-partner-1",
    attrs: {
      "src": require("./../assets/bc-cdc-logo.jpg")
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-1",
    attrs: {
      "src": require("./../assets/fnha-logo.jpg")
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-1",
    attrs: {
      "src": require("./../assets/fha-logo.jpg")
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-1",
    attrs: {
      "src": require("./../assets/iha-logo.jpg")
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    staticClass: "logo-partner-2",
    attrs: {
      "src": require("./../assets/viha-logo.jpg")
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-2",
    attrs: {
      "src": require("./../assets/nha-logo.jpg")
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-2",
    attrs: {
      "src": require("./../assets/phc-logo.jpg")
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-2",
    attrs: {
      "src": require("./../assets/vch-logo.jpg")
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a4b75ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/web/components/Home.vue
// module id = 127
// module chunks = 0